import Dashboard from "../../../Pages/Dashboard/Dashboard";
import AllBatteries from "../../../Pages/AllBatteries/AllBatteries";
import Diagnostics from "../../../Pages/Diagnostics/Diagnostics";
import SpecificBattery from "../../../Pages/SpecificBattery/SpecificBattery";
import BatteryHealth from "../../../Pages/BatteryHealth/BatteryHealth";
import Anomaly from "../../../Pages/Anomaly/Anomaly";
import Warranty from "../../../Pages/Warranty/Warranty";
import Map from "../../../Pages/Map/Map";
import Reports from "../../../Pages/Reports";
import DigitalTwinsList from "../../../Pages/DigitalTwinsList/DigitalTwinList";
import Overview from "../../../Pages/Overview/Overview";
import ChargingAnalytics from "../../../Pages/ChargingAnalytics/ChargingAnalytics";
import AlertAnalytics from "../../../Pages/AlertAnalytics/AlertAnalytics";
import AlertDrillDown from "../../../Pages/AlertDrillDown/AlertDrillDown";
import BmsFaults from "../../../Pages/BmsFaults/BmsFaults";
import PlatformAlerts from "../../../Pages/PlatformAlerts/PlatformAlerts";
import FleetPerformance from "../../../Pages/FleetPerformance/FleetPerformance";
import ResourceOnboarding from "../../../Pages/ResourceOnboarding/ResourceOnboarding";
import AccessManagement from "../../../Pages/AccessManagement/AccessManagement";
import BatteryIntelligence from "../../../Pages/BatteryIntelligence/BatteryIntelligence";
import DataDownload from "../../../Pages/DataDownload/DataDownload";
import SupportedLocations from "../../../Pages/OrgSettings/SupportedLocations";
import ClientApiManagement from "../../../Pages/OrgSettings/ClientApiManagement";
import AssetManagement from "../../../Pages/AssetManagement/AssetManagement";

const Components = {
  Alerts: Dashboard, //Alerts
  AllBatteries: AllBatteries,
  Diagnostics: Diagnostics,
  SpecificBattery: SpecificBattery,
  BatteryHealth: BatteryHealth,
  Anomaly: Anomaly,
  Warranty: Warranty,
  Reports: Reports,
  Map: Map,
  DigitalTwin: DigitalTwinsList,
  ChargingAnalytics: ChargingAnalytics,
  AlertAnalytics: AlertAnalytics,
  AlertDrillDown: AlertDrillDown,
  Overview: Overview,
  BMSAlertV2: BmsFaults,
  PlatformAlertsV2: PlatformAlerts,
  FleetPerformance: FleetPerformance,
  ResourceOnboarding: ResourceOnboarding,
  AccessManagement: AccessManagement,
  BatteryIntelligence : BatteryIntelligence,
  DataDownload: DataDownload,
  SupportedLocations: SupportedLocations,
  ClientApiManagement: ClientApiManagement,
  AssetManagement: AssetManagement,
};

export default Components;
